<template>
  <div>
    <device-list deviceType="SBGXFL_B"></device-list>
  </div>
</template>

<script>
import DeviceList from "./DeviceList.vue";
export default {
  components: {
    DeviceList,
  },
};
</script>

<style lang="scss" scoped></style>
